'use client'

import { DataList } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { FaCheck } from 'react-icons/fa'
import { ParsedPricingInfo } from 'utils/apiUtils/prices'
import { removeDecimals } from 'utils/removeDecimals'

type Props = {
  pricing: ParsedPricingInfo
  cancelationAvailable?: boolean
  inverted?: boolean
}

const LeidSmartDescription = ({ pricing, cancelationAvailable = true, inverted = false }: Props): JSX.Element => {
  const { t } = useTranslation()

  return (
    <DataList.Root variant="bold">
      {cancelationAvailable && (
        <DataList.Item>
          <DataList.ItemLabel textDecoration="underline">
            <FaCheck style={{ marginLeft: '2px' }} size={10} /> {t('leidSmart.leidSmartShortTerms.terms.terms1.title')}
          </DataList.ItemLabel>
          <DataList.ItemValue
            marginLeft="14px"
            paddingTop="8px"
            color={inverted ? 'white' : 'black'}
            lineHeight="normal"
          >
            {t('leidSmart.leidSmartShortTerms.terms.terms1.description')}
          </DataList.ItemValue>
        </DataList.Item>
      )}

      {pricing.deductiblesPrice !== undefined && (
        <DataList.Item>
          <DataList.ItemLabel textDecoration="underline">
            <FaCheck style={{ marginLeft: '2px' }} size={10} />{' '}
            {t('leidSmart.leidSmartShortTerms.terms.terms2.title', {
              amount: removeDecimals(pricing.deductiblesAmount ?? 10000),
            })}
          </DataList.ItemLabel>
          <DataList.ItemValue
            marginLeft="14px"
            paddingTop="8px"
            color={inverted ? 'white' : 'black'}
            lineHeight="normal"
          >
            {t('leidSmart.leidSmartShortTerms.terms.terms2.description', {
              amount: removeDecimals(pricing.deductiblesPrice),
              currency: t('nok'),
            })}
          </DataList.ItemValue>
        </DataList.Item>
      )}

      <DataList.Item>
        <DataList.ItemLabel textDecoration="underline">
          <FaCheck style={{ marginLeft: '2px' }} size={10} /> {t('leidSmart.leidSmartShortTerms.terms.terms3.title')}
        </DataList.ItemLabel>
        <DataList.ItemValue marginLeft="14px" paddingTop="8px" color={inverted ? 'white' : 'black'} lineHeight="normal">
          {t('leidSmart.leidSmartShortTerms.terms.terms3.description')}
        </DataList.ItemValue>
      </DataList.Item>
    </DataList.Root>
  )
}

export default LeidSmartDescription
